import styles from "./ProgramDashboard.module.css";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";
import { IoMdTrash } from "react-icons/io";
import Dynamic from "../../components/DynamicTable/DynamicTable";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { useState } from "react";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import Action from "../../components/Action/Action";
import IconAndName from "../../components/IconAndName/IconAndName";
import { FaUserPlus } from "react-icons/fa";
import { LuClock3 } from "react-icons/lu";
import CopyRight from "../../components/CopyRight/CopyRight";

const data = [
  {
    _id: "1",
    name: "Program 1",
    dateRange: "29/05/25 - 30/05/25",
    totalStudents: 12,
    studentExpected: 10,
    studentSignedIn: 8,
    totalStaff: 6,
    staffExpected: 4,
    staffSignedIn: 3,
  },
 
];


function Program() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const handleAddProgram = () => {
    dispatch(openModal("addProgram"));
  };
  const handlecheckAvailability = () => {
    dispatch(openModal("checkAvailability"));
  };

  // GCD-based ratio function
  const getRatio = (a, b) => {
    if (b === 0) return "N/A";
    const gcd = (x, y) => (y === 0 ? x : gcd(y, x % y));
    const d = gcd(a, b);
    return `${a / d}:${b / d}`;
  };

  const getColumnData = (data) => {
    return data?.map((item) => {
      const isChecked = selectedIds.includes(item._id);

      const totalStudents = item.totalStudents ?? 0;
      const studentExpected = item.studentExpected ?? 0;
      const studentSignedIn = item.studentSignedIn ?? 0;

      const totalStaff = item.totalStaff ?? 0;
      const staffExpected = item.staffExpected ?? 0;
      const staffSignedIn = item.staffSignedIn ?? 0;

      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              if (checked) {
                setSelectedIds((prev) => [...prev, item._id]);
              } else {
                setSelectedIds((prev) => prev.filter((id) => id !== item._id));
              }
            }}
          />
        ),
        programName: (
          <LogoWithName name={item.name} dateRange={item.dateRange} />
        ),
        totalStudents,
        studentExpected,
        studentSignedIn,
        totalStaff,
        staffExpected,
        staffSignedIn,
        expectedRatio: getRatio(studentExpected, staffExpected),
        currentRatio: getRatio(studentSignedIn, staffSignedIn),
      };
    });
  };
  

  const displayData = getColumnData(data);

  const headingsData = [
  {
    title: (
      <input
        type="checkbox"
        checked={selectedIds.length === data.length}
        onChange={(e) => {
          const checked = e.target.checked;
          if (checked) {
            const allIds = data.map((item) => item._id);
            setSelectedIds(allIds);
          } else {
            setSelectedIds([]);
          }
        }}
      />
    ),
    accessor: "checkBox",
  },
  { title: "Program Name", accessor: "programName" },

  // Students columns
  { title: "Students", accessor: "totalStudents" },
  { title: "Expected", accessor: "studentExpected" },
  { title: "Signed in", accessor: "studentSignedIn" },

  // Staff columns
  { title: "Staffs", accessor: "totalStaff" },
  { title: "Expected", accessor: "staffExpected" },
  { title: "Signed in", accessor: "staffSignedIn" },

  // Ratios
  { title: "Expected ratio", accessor: "expectedRatio" },
  { title: "Current ratio", accessor: "currentRatio" },
];

  

  return (
    <div className={styles.copyright}>
      <div className={styles.programcontainer}>
        <div className={styles.container}>
          <div className={styles.resultandcount}>
            <ResultAndCount
              label="Total Number Of Programs"
              count={10}
              bgColor="rgba(from var(--Success_Color) r g b / 0.4)"
              textColor="Black_Color"
            />
            <ResultAndCount
              label="Students starting Program This Week"
              count={2}
              bgColor="rgba(from var(--Primary_Color) r g b / 0.35)"
              textColor="Black_Color"
            />
            <ResultAndCount
              label="Students Leaving Program This Week"
              count={5}
              bgColor="rgba(from var(--Error_Color) r g b / 0.4)"
              textColor="Black_Color"
            />
            <ResultAndCount
              label="Students Without Active Program"
              count={1}
              bgColor="rgba(from var(--Warning_Color) r g b / 0.3)"
              textColor="Black_Color"
            />
          </div>

          <div className={styles.totalstudentcard}>
            <div className={styles.studentsection}>
              <div className={styles.search}>
                <SearchBar
                  placeholder="Search Program"
                  onChange={(e) => console.log(e.target.value)}
                />
              </div>

              <div className={styles.dropdown}>
                <Dropdown label="Program" options={["Room1", "Room2"]} />
                <Dropdown label="Active" options={["Active", "Inactive"]} />
                <div className={styles.dateWrapper}>
                  <input
                    type="date"
                    className={styles.dateInput}
                    onChange={(e) => console.log(e.target.value)}
                  />
                </div>
                <IconAndName
                  title="Apply"
                  bgColor="Primary_Color"
                  onClick={handlecheckAvailability}
                />
              </div>
            </div>

            <div className={styles.dynamicdata}>
              <Dynamic
                headings={headingsData}
                columnData={displayData.slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )}
              />
            </div>

            <div className={styles.paginationTable}>
              <PaginationTable
                data={displayData}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
      <CopyRight />
    </div>
  );
}

export default Program;
